import type { SerializedEditorState } from 'lexical';
import { NotificationOperation } from '@/store/app';
import { editorValueToPlainText } from '@/utils/editor-conversion';

export const getNotificationMessage = (
	operation: NotificationOperation,
	cardTitle: SerializedEditorState | string
) => {
	const cleanTitle = editorValueToPlainText(cardTitle);

	const messages: Record<NotificationOperation, string> = {
		[NotificationOperation.CREATE]: 'has been successfully created',
		[NotificationOperation.UPDATE]: 'has been successfully updated',
		[NotificationOperation.REMOVE]: 'has been successfully removed',
		[NotificationOperation.REMOVE_FROM_CANVAS]:
			'has been successfully removed from canvas',
		[NotificationOperation.CLONE]: 'has been successfully cloned',
		[NotificationOperation.REVERT_TO_ORIGINAL]: 'has been successfully reverted'
	};

	const suffix = messages[operation];
	if (!suffix) {
		return '';
	}
	return `The ${cleanTitle} ${suffix}`;
};
